module.exports = __webpack_public_path__ + "images/landing_get_it_from_microsoft.10fd195f404f4d715c98f2f471b28d2e.png";